'use client';

import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';
import { EnergyType } from '@energy-retailer/constants';
import { type Dispatch, type SetStateAction } from 'react';

import { Modal, ModalButton, BaseModalContent } from '@/components/modal';

type FlowSwitchModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  description?: string;
  onContinue?: () => void;
  onCancel?: () => void;
};

export const FlowSwitchModal = ({
  isModalOpen = false,
  setIsModalOpen,
  onCancel,
  onContinue,
  description = 'You’ve currently got a gas plan selected, would you like to remove this from your cart?',
}: FlowSwitchModalProps) => {
  const { setGasPlanId, setGasPlanSlug, setGasFluxId, setCurrentStep } = useJoinFormStore();

  function closeModal() {
    setIsModalOpen(false);
    if (onCancel) {
      onCancel();
    }
  }

  function openModal() {
    setIsModalOpen(true);
  }

  return (
    <Modal
      heading="Before we continue"
      description={description}
      isModalOpen={isModalOpen}
      openModal={openModal}
      expandHeader
    >
      <BaseModalContent
        buttonComponent={
          <>
            <ModalButton
              variant="primary"
              onClick={() => {
                setGasPlanId('');
                setGasPlanSlug('');
                setGasFluxId({ productId: null });
                setCurrentStep(EnergyType.Electricity);
                if (onContinue) {
                  onContinue();
                }
              }}
            >
              Remove from cart
            </ModalButton>

            <ModalButton
              variant="tertiary"
              onClick={closeModal}
            >
              Cancel
            </ModalButton>
          </>
        }
      />
    </Modal>
  );
};
